"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconCaret = _interopRequireDefault(require("../../../shared/icons/icon-caret.svg"));

var _iconBackArrow = _interopRequireDefault(require("../../../shared/icons/icon-back-arrow.svg"));

var _CustomReactMarkdown = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/CustomReactMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var uuid = require('uuid/v4');

var NavPane = function NavPaneComponent(_ref) {
  var activePane = _ref.activePane,
      backItemId = _ref.backItemId,
      displayName = _ref.displayName,
      paneId = _ref.paneId,
      goToNavPane = _ref.goToNavPane,
      navItems = _ref.navItems,
      goToRoot = _ref.goToRoot;
  var backHandler = goToRoot || goToNavPane;
  return activePane === paneId && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    key: uuid(),
    className: "nav-drawer__link-list__item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    className: "nav-drawer__link-back",
    onClick: function onClick() {
      return backHandler(backItemId);
    },
    onKeyPress: function onKeyPress() {
      return backHandler(backItemId);
    }
  }, /*#__PURE__*/_react["default"].createElement(_iconBackArrow["default"], {
    className: "nav-drawer__arrow"
  }), /*#__PURE__*/_react["default"].createElement("span", null, displayName))), navItems.map(function (item) {
    if (item.items) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: uuid(),
        className: "nav-drawer__link-list__item"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        role: "button",
        tabIndex: "0",
        className: "nav-drawer__link",
        onClick: function onClick() {
          return goToNavPane("".concat(backItemId, "_subGroups_").concat(item.name));
        },
        onKeyPress: function onKeyPress() {
          return goToNavPane("".concat(backItemId, "_subGroups_").concat(item.name));
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, item.name), /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
        className: "nav-drawer__caret"
      })));
    }

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: uuid(),
      className: "nav-drawer__link-list__item"
    }, /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
      className: "nav-drawer__link-markdown",
      source: item
    }));
  }));
};

NavPane.propTypes = {
  activePane: _propTypes["default"].string,
  goToRoot: _propTypes["default"].func,
  paneId: _propTypes["default"].string.isRequired,
  backItemId: _propTypes["default"].string.isRequired,
  displayName: _propTypes["default"].string.isRequired,
  navItems: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})])).isRequired,
  goToNavPane: _propTypes["default"].func.isRequired
};
NavPane.defaultProps = {
  activePane: null,
  goToRoot: null
};
var _default = NavPane;
exports["default"] = _default;